<!-- 移库列表 -->
 <template>
    <div >
        <el-form class="demo-form-inline" :inline="true" ref="inventoryMoveSeach" :model="inventoryMoveSeach" 
             size="mini" label-width="120px"> 
            <el-form-item label="提单号" prop="blNo"> 
                <el-input  v-model="inventoryMoveSeach.blNo" placeholder="请输入提单号" clearable ></el-input>
            </el-form-item>
            <el-form-item label=""> 
                <el-button size="mini" @click="resetForm">重置</el-button>
                <el-button type="primary" size="mini" @click="wmsGetStockList">搜索</el-button>
                <el-button type="primary" size="mini" @click="newMoveStock">新建移库任务单</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { jumpInWarehouse } from '@/config/jumpInWarehouse.js'
export default {
    name: 'inventoryMoveList',
    components:{
    },
    watch: { 
        
    },
    data() {
        return{
            hasHandledToken: false, // 是否处理过token
            inventoryMoveSeach:{},
        }
    },
    created() {

    },

    mounted() {

    },
    methods: {
        newMoveStock(){
            jumpInWarehouse(this, localStorage.getItem('token'), localStorage.getItem('name'), 'add', 'move')
        },
    },
}
</script>
<style style lang="less" scoped>

</style>